import * as React from 'react'
import { Card, CardContent } from '@material-ui/core'
import { ImgWithSkeleton } from 'components/Card'
import { makeStyles } from '@material-ui/core/styles'
import LockIcon from 'components/Icon/Lock_Black'

type Props = {
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  item: {
    id: string
    thumbnail: {
      front?: { uri?: string }
      back?: { uri?: string }
    }
    isPremium: boolean
    price: number
  }
  showOnlyCard?: boolean
}
const Component: React.FC<Props> = ({
  item,
  onClick,
  showOnlyCard = false,
}) => {
  const s = useStyle({})

  return (
    <Card elevation={0} className={s.card}>
      <div onClick={onClick} className={s.action}>
        <ImgWithSkeleton
          id={item.id}
          src={item.thumbnail?.front?.uri}
          imgClassName={s.img}
          imgWrapperClassName={s.imgWrapper}
          aspectRatio={1.285}
        />
        {!showOnlyCard && (
          <CardContent classes={{ root: s.content }}>
            {item.price != null && (
              <span className={s.price}>¥{item.price}</span>
            )}
            {item.isPremium && <LockIcon />}
          </CardContent>
        )}
      </div>
    </Card>
  )
}

export default Component

const useStyle = makeStyles(({ breakpoints: b }) => ({
  img: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0 /* Make the picture taking the size of it's parent */,
    width: '100%' /* This if for the object-fit */,
    height: '100%' /* This if for the object-fit */,
    objectFit: 'contain',
    objectPosition: 'center',
    filter: 'drop-shadow(0px 10px 10px rgba(0, 0, 0, 0.1))',
  },
  imgWrapper: {
    width: '100%',
    height: '100%',
  },
  action: {
    cursor: 'pointer',
  },
  card: {
    width: '100%',
    padding: 13,
    [b.down('xs')]: {
      padding: 5,
    },
  },
  content: {
    padding: '10px 0 0 0',
    display: 'flex',
    alignItems: 'center',
  },
  price: {
    fontWeight: 600,
    fontSize: 20,
    flex: '1 1 auto',
    fontFamily: 'Helvetica',
    [b.down('xs')]: {
      fontSize: 16,
    },
  },
}))
